import { formatDate } from "date-fns";

export function isValidDate(date: Date | null | undefined): boolean {
  return (
    !!date && !isNaN(date.getTime()) && !(date.getFullYear() === 1970 && date.getMonth() === 0 && date.getDate() === 1)
  );
}

export function formatValidDate(date: Date | null | undefined, format = "yyyy-MM-dd HH:mm:ss"): string | null {
  if (!isValidDate(date)) {
    return null;
  }
  return formatDate(date as Date, format);
}
